import React from "react";
import { Link } from "react-router-dom";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { Filter } from "react-feather";
import PropTypes from "prop-types";

const TableTop = ({
  onSearch,
  toggleFilterVisibility,
  isFilterVisible,
  showToggle = false,
  searchPlaceHolder = "Search",
  otherProps = "",
}) => {
  return (
    <div className="table-top">
      <div className="search-set">
        <div className="search-input">
          <input
            type="text"
            placeholder={searchPlaceHolder}
            className="form-control form-control-sm formsearch"
            onChange={(e) => {
              onSearch(e.target.value);
            }}
          />
          <Link to className="btn btn-searchset">
            <i data-feather="search" className="feather-search" />
          </Link>
        </div>
      </div>
      {showToggle && (
        <div className="search-path">
          <button
            className={`btn btn-filter ${isFilterVisible ? "setclose" : ""}`}
            id="filter_search"
          >
            <Filter className="filter-icon" onClick={toggleFilterVisibility} />
            <span onClick={toggleFilterVisibility}>
              <ImageWithBasePath src="assets/img/icons/closes.svg" alt="img" />
            </span>
          </button>
        </div>
      )}
      {otherProps}
    </div>
  );
};

TableTop.propTypes = {
  onSearch: PropTypes.func.isRequired,
  toggleFilterVisibility: PropTypes.func.isRequired,
  isFilterVisible: PropTypes.bool.isRequired,
  showToggle: PropTypes.bool,
  otherProps: PropTypes.any,
  searchPlaceHolder: PropTypes.string,
};

export default TableTop;
